module.exports = "/_next/static/images/main-visual-menu-cooking-078336a4400ec7011864697cba1dd878.jpg";